
import { call, put, takeEvery, all, select} from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getUserPageRefresh } from '../auth/sagas';

const getData = () => new Promise((resolve, reject) => {
    axios.get(process.env.REACT_APP_BACKEND_URL + "/meetingRoom/billingReportCount").then(
        response => { console.log("response of billing", response); resolve(response); },
        error => reject(error)
    )
})

function* getSearchData({ searchFields }) {
    const userDefined = yield select(state => state.authReducer.user);

    if (!userDefined || !userDefined.role) {
        yield call(getUserPageRefresh);
    }
    yield put({ type: actionTypes.GET_SEARCH_DATA_LIST_REQUEST })
}

function* getAllBillingReportData() {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            console.log("getallbilling data resetting user state");
            yield call(getUserPageRefresh);
        }
        else {console.log("getallbilling data userAlreadyDefined", userDefined);}
        const data = yield call(getData);
        console.log("data returned", data)
        yield put({
            type: actionTypes.GET_BILLING_REPORT_COUNT_SUCCESS,
            payload: data
        })
    } catch (e) {

    }
}

const billingReportSagas = [
takeEvery(actionTypes.GET_BILLING_REPORT_COUNT, getAllBillingReportData),
takeEvery(actionTypes.GET_SEARCH_DATA_REQUEST, getSearchData)


];

export { billingReportSagas }
